import React from 'react';

const ArrowRight = ({ className = '' }: { className: string }) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g id="Frame 625760">
        <path
          id="Vector"
          d="M18.4993 12.285C18.4952 11.8463 18.3185 11.4268 18.0073 11.1175L14.4297 7.53156C14.2734 7.37624 14.0621 7.28906 13.8418 7.28906C13.6215 7.28906 13.4101 7.37624 13.2539 7.53156C13.1757 7.60909 13.1136 7.70132 13.0713 7.80295C13.029 7.90457 13.0072 8.01357 13.0072 8.12366C13.0072 8.23375 13.029 8.34275 13.0713 8.44437C13.1136 8.54599 13.1757 8.63823 13.2539 8.71575L15.9975 11.4511H8.65815C8.43698 11.4511 8.22487 11.5389 8.06847 11.6953C7.91208 11.8517 7.82422 12.0638 7.82422 12.285C7.82422 12.5062 7.91208 12.7183 8.06847 12.8747C8.22487 13.0311 8.43698 13.1189 8.65815 13.1189H15.9975L13.2539 15.8626C13.0968 16.0185 13.0082 16.2304 13.0074 16.4517C13.0066 16.673 13.0938 16.8855 13.2497 17.0426C13.4056 17.1996 13.6175 17.2883 13.8388 17.2891C14.0601 17.2898 14.2727 17.2027 14.4297 17.0468L18.0073 13.4608C18.3205 13.1495 18.4974 12.7266 18.4993 12.285Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export default ArrowRight;
